import { z } from 'zod';
import { transferOrderQuantitySchema } from './item-quantity.js';
import { lowercasedRequiredUuidString } from './lowercased-required-uuid-string.js';
export const returnTransferOrderPickDrawEntryInputSchema = z.object({
    pickItemId: lowercasedRequiredUuidString('Pick draw is required.', 'Invalid pick draw.'),
    /** Absent returns the whole draw. */
    quantity: transferOrderQuantitySchema.nullish(),
    /** What the caller saw picked on the draw, so a replayed or stale return is refused instead of applied twice. */
    expectedQty: transferOrderQuantitySchema,
});
//# sourceMappingURL=return-pick-draw-entry-input.js.map